import { NgModule } from '@angular/core';
import { KrakenChipComponent } from './kraken-chip.component';
import { CommonModule } from '@angular/common';
import { KrakenTooltipModule } from '@kraken-ui/kraken-tooltip';

@NgModule({
  declarations: [
    KrakenChipComponent
  ],
  imports: [
    CommonModule,
    KrakenTooltipModule
  ],
  exports: [
    KrakenChipComponent
  ]
})
export class KrakenChipModule { }
